import {LoadingBar} from '../common/loadingBar';
import {UIImage} from '../common/ui/uiImage';
import {UIPanel} from '../common/ui/uiPanel';
import {UIScreen} from '../common/ui/uiScreen';
import {UIText} from '../common/ui/uiText';
import {Game, GameMode} from './game';
import {GameStyle} from './gameStyle';

export class SplashScreen extends UIScreen {
  protected loadingBar: LoadingBar;
  protected fontsLoaded: boolean;

  public build() {
    let background = new UIPanel({
      fitParent: {left: 0, top: 0, right: 0, bottom: 0},
      gradient: {
        startColor: GameStyle.backgroundColors.game.inner,
        endColor: GameStyle.backgroundColors.game.outer,
        type: 'vertical'
      },
      parent: this
    });

    let logo = new UIImage({
      url: require('./assets/logo.png'),
      position: {x: 0, y: -100},
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      parent: this
    });

    this.loadingBar = new LoadingBar({
      anchor: {x: 0.5, y: 1},
      pivot: {x: 0.5, y: 1},
      position: {x: 0, y: -60},
      size: {x: 250, y: 10},
      visible: false,
      parent: this
    });

    let copyright = new UIText({
      text: 'Copyright 2023, Monster Ideas Inc.',
      fontFamily: 'arial',
      fontSize: 14,
      color: '#ffffff80',
      anchor: {x: 0.5, y: 1},
      pivot: {x: 0.5, y: 1},
      position: {x: 0, y: -20},
      parent: this
    });
  }

  public onWake() {
    this.loadingBar.visible = true;
    this.loadingBar.start();

    let webFont = require('webfontloader');

    this.fontsLoaded = false;
    webFont.load({
      google: {families: ['Roboto']},
      active: () => {
        this.fontsLoaded = true;
      },
      inactive: () => {
        this.fontsLoaded = true;
      }
    });

    // Game.game.cardsManager.loadCardArt();

    setTimeout(() => {
      Game.instance.gameScreen.show();
    }, 2000);
  }
}